import { render, staticRenderFns } from "./FormElement.vue?vue&type=template&id=4c8f0052&scoped=true"
import script from "./FormElement.vue?vue&type=script&lang=ts"
export * from "./FormElement.vue?vue&type=script&lang=ts"
import style0 from "./FormElement.vue?vue&type=style&index=0&id=4c8f0052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8f0052",
  null
  
)

export default component.exports